export const errorCodes = {
    REQUEST_ERROR: 1000,
    user: {
        GET_USER_STATS_ERROR: 1001,
        GET_USER_PROFILE_ERROR: 1002,
        SET_PASSWORD_ERROR: 1005,
        CREATE_USER_TEAM_ERROR: 1006,
        GET_USER_TEAM_ERROR: 1007,
        UPDATE_USER_TEAM_ERROR: 1008,
        GET_TEAMS_ERROR: 1009,
        FEEDBACK_FAILED: 1010
    },
    userManager: {
        TEAM_NAME_NOT_UNIQUE: 2001,
        AGENT_ALREADY_IN_OTHER_TEAM: 2002
    },
    member: {
        GET_MEMBER_STATS_ERROR: 3001,
        GET_MEMBER_COMPARISON_STATS_ERROR: 3002,
        GET_MEMBER_PROFILE_ERROR: 3003
    },
    auth: {
        ACCESS_TOKEN_EXPIRED: 4001,
        REFRESH_TOKEN_EXPIRED: 4002,
        LOGIN_FAILED: 4003,
        RECOVERY_FAILED: 4004,
        RECOVERY_RESET_FAILED: 4005
    },
    keywordManager: {
        VALIDATION_ERROR: 5001
    }
};
